export default __webpack_public_path__ + "static/media/(81).71a7ff49.jpg";